module.exports = __webpack_public_path__ + "img/redirect.f06a3850.svg";